module.exports = __webpack_public_path__ + "static/media/logo_yellow.77eaca29.svg";